import { render, staticRenderFns } from "./app-image-lightbox-overlay.vue?vue&type=template&id=4590eee8"
import script from "./app-image-lightbox-overlay.vue?vue&type=script&lang=ts"
export * from "./app-image-lightbox-overlay.vue?vue&type=script&lang=ts"
import style0 from "./app-image-lightbox-overlay.vue?vue&type=style&index=0&id=4590eee8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4590eee8')) {
      api.createRecord('4590eee8', component.options)
    } else {
      api.reload('4590eee8', component.options)
    }
    module.hot.accept("./app-image-lightbox-overlay.vue?vue&type=template&id=4590eee8", function () {
      api.rerender('4590eee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-image-lightbox/app-image-lightbox-overlay.vue"
export default component.exports